import { setIsUpdating } from './actions/resourcesActions';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { useInitRedux } from './redux';
import { ShowStaffStorage, UsernameStorage } from './local-storage/username-storage';
import { logger } from '@visikon/utils/src/logger';

export function useInit() {
  const store = useInitRedux();
  initServiceWorkers(store);

  // Remove old storage keys
  try {
    UsernameStorage.remove();
    ShowStaffStorage.remove();
  } catch (error) {
    logger.error('Error removing "Show Staff" or "username" storage items:', error);
  }

  return { store };
}

export function initServiceWorkers(store: any) {
  const config = {
    onUpdate: (registration) => {
      // force unregister + reload
      store.dispatch(setIsUpdating());
      registration.unregister().then(() => {
        window.location.reload();
      });
    },
    onSuccess: (registration) => {},
  };

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://cra.link/PWA
  serviceWorkerRegistration.register(config);
}
